import React from 'react';
import { KineticObject } from './KineticObject';
import { PageAtmosphereVariant } from './PageAtmosphere';

export function EditorialHero({ eyebrow, title, accent, description, variant, href, action, compact = false }: {
  eyebrow: string; title: string; accent: string; description: string;
  variant: PageAtmosphereVariant; href: string; action: string; compact?: boolean;
}) {
  return <section className={`editorial-hero${compact ? ' editorial-hero--compact' : ''}`} aria-labelledby="page-heading">
    <KineticObject variant={variant} className="editorial-hero__object" label={`${eyebrow.toLowerCase()} sculpture`} />
    <div className="editorial-hero__copy">
      <p className="editorial-label">Cognixis / {eyebrow}</p>
      <h1 id="page-heading"><span>{title}</span>{' '}<em>{accent}</em></h1>
      <p className="editorial-hero__description">{description}</p>
      <a className="editorial-button" href={href}>{action}<span aria-hidden="true">↗</span></a>
    </div>
    <div className="editorial-hero__foot"><span>Intelligence, made useful.</span><a href={href}>Explore this page <span aria-hidden="true">↓</span></a></div>
  </section>;
}
